import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * Imagecard element, used for visual information sections like a dashboard tile
 * Normally used to display an image in the top section and wrap a listitem element in the bottom section
 *
 * @prop {String} img - used to define an image to be used as background
 * @prop {Boolean} bgprimary - used to set the primary background color
 * @prop {Boolean} bgsecondary - used to set the secondary background color
 * @prop {Boolean} bgtertiary - used to set the tertiary background color
 * @prop {Boolean} hover - used to enable pointer events for listItems in the bottom slot of this card
 * @slot top - This slot is used to hold items in the top section of the imagecard element
 * @slot bottom - This slot is used to hold items in the bottom section of the imagecard element (normally listitems elements)
 *
 */
let SDBContentInfoCard = class SDBContentInfoCard extends LitElement {
    constructor() {
        super(...arguments);
        this.headline = '';
        this.bgsecondary = false;
        this.bgtertiary = false;
        this.hover = false;
    }
    render() {
        return html `
            <section id="infoWrapper">
                ${this.headline
            ? html `<div class="headline">
                          <span>${this.headline}</span>
                      </div> `
            : html ``}
            </section>
            <section id="contentWrapper">
                <slot name="bottom"></slot>
            </section>
        `;
    }
};
SDBContentInfoCard.styles = [
    elements,
    css `
            :host {
                background: white;
                position: relative;
                height: 100%;
                width: 100%;
                display: grid;
                grid-template-columns: 1fr;
                grid-template-rows: 60px auto; /* rows will use full available height */
                grid-template-areas:
                    'info'
                    'content';
                transition: box-shadow 0.1s ease-in-out;
            }

            section#infoWrapper {
                grid-area: info;
                position: relative;
                display: block;
                width: 100%;
                height: 60px;
                background-color: var(--theme-primary);
                color: var(--text-light);
            }

            section#infoWrapper div.headline {
                display: flex;
                height: 60px;
                width: calc(100% - 30px);
                padding: 0 15px;
                align-items: center;
                justify-content: start;
            }

            section#infoWrapper div.headline span {
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: hidden;
            }

            :host([bgsecondary]) section#infoWrapper {
                background-color: var(--theme-secondary);
            }

            :host([bgtertiary]) section#infoWrapper {
                background-color: var(--theme-tertiary);
            }

            section#contentWrapper {
                grid-area: content;
                display: flex;
                flex-flow: column wrap;
                justify-items: stretch;
                align-items: stretch;
                background: white;
                padding: 0 30px;
            }

            :host([hover]:hover),
            :host([hover]:hover) ::slotted(*) {
                cursor: pointer;
            }

            :host([hover]:hover) {
                box-shadow: 0px 4px 14px 1px rgba(0, 0, 0, 0.25);
            }
        `,
];
__decorate([
    property({ type: String })
], SDBContentInfoCard.prototype, "headline", void 0);
__decorate([
    property({ type: Boolean })
], SDBContentInfoCard.prototype, "bgsecondary", void 0);
__decorate([
    property({ type: Boolean })
], SDBContentInfoCard.prototype, "bgtertiary", void 0);
__decorate([
    property({ type: Boolean })
], SDBContentInfoCard.prototype, "hover", void 0);
SDBContentInfoCard = __decorate([
    customElement('sdb-content-infocard')
], SDBContentInfoCard);
export { SDBContentInfoCard };
//# sourceMappingURL=sdb-content-infocard.js.map